var map = {
	"./template.betgalaxy": 1078,
	"./template.betgalaxy.tsx": 1078,
	"./template.betprofessor": 2065,
	"./template.betprofessor.tsx": 2065,
	"./template.default": 410,
	"./template.default.tsx": 410,
	"./template.forsport": 1079,
	"./template.forsport.tsx": 1079,
	"./template.puntgenie": 2066,
	"./template.puntgenie.tsx": 2066,
	"./template.ts": 967,
	"./template.wellbet": 1991,
	"./template.wellbet.tsx": 1991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2421;